<template>
  <div class="login-page relative flex min-h-screen items-center justify-center overflow-hidden px-3 py-8">
    <div class="login-page-backdrop pointer-events-none absolute inset-0" aria-hidden="true"></div>
    <LoginFormCard @close="closeLogin" />
  </div>
</template>

<script>
import LoginFormCard from '../components/LoginFormCard.vue'

export default {
  name: 'Login',
  components: { LoginFormCard },
  methods: {
    closeLogin() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.login-page {
  background: #12141a;
}
.login-page-backdrop {
  background:
    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(56, 100, 180, 0.18) 0%, transparent 55%),
    linear-gradient(180deg, #0e1014 0%, #161922 45%, #12141a 100%);
}
</style>
